<template>
  <div class="nopads pt-1">
    <hr class="nopads mt-1">
    <h4 class="form-header">
      {{ $t('velho_equipment.damages_title') }}
    </h4>
    <div class="row">
      <div class="col-sm-10 nopads">
        <velho-equipment-damage-editor
          :item="newDamage"
          :is-percentage-visible="isPercentageVisible"
        />
      </div>
      <div class="col-sm-2 nopads d-flex justify-content-end pl-1 pr-1 pt-4">
        <button
          class="btn btn-sm btn-info form-button"
          style="height: 2.2em"
          :disabled="isAddDisabled"
          @click.stop="addDamage"
        >
          {{ $t('common.add') }}
        </button>
      </div>
    </div>
    <template v-if="items.length === 0">
      <span class="item-text pl-2 pb-2">{{ $t('velho_equipment.damage.no_damage_info') }}</span>
    </template>
    <template v-if="items.length > 0">
      <div class="row nopads">
        <div class="col-sm-12 nopads">
          <span class="span-title">{{ $t('velho_equipment.damage_title') }}</span>
        </div>
      </div>
      <div
        v-for="(damage, index) in items"
        :key="index"
      >
        <div class="row">
          <div class="col-sm-10 nopads">
            <velho-equipment-damage-editor
              :item="damage"
              :is-percentage-visible="isPercentageVisible"
            />
          </div>
          <div class="col-sm-2 d-flex justify-content-end nopads pl-1 pr-1 pt-4">
            <button
              class="btn btn-sm btn-danger form-button"
              style="height: 2.2em"
              @click.stop="removeDamageByIndex(index)"
            >
              {{ $t('common.remove') }}
            </button>
          </div>
        </div>
        <hr
          v-if="index < items.length - 1"
          class="nopads mt-1 mb-1"
        >
      </div>
    </template>
  </div>
</template>

<script>
import VelhoEquipmentDamageEditor from "@/components/velho/VelhoEquipmentDamageEditor";

export default {
    name: 'VelhoEquipmentDamages',
    components: {VelhoEquipmentDamageEditor},
    mixins: [],
    props: {
        items: {
            type: Array
        },
        isPercentageVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            newDamage: {
                damage_type: null,
                damage_category: null,
                repair_priority_level: null,
                area: null,
                percentage: null
            }
        }
    },
    computed: {
        isAddDisabled() {
            return !this.newDamage.damage_type
        }
    },
    mounted() {
        if(!this.items) {
            this.items = []
        }
    },
    methods: {
        addDamage: function() {
            this.items.push(this.newDamage)
            this.newDamage = {
                damage_type: null,
                damage_category: null,
                repair_priority_level: null,
                area: null,
                percentage: null
            }
        },
        removeDamageByIndex: function(index) {
            this.items.splice(index, 1);
        }
    }
}
</script>
